const extractPathFromUrl = (url: string): string => {
    try {
        return new URL(url).pathname;
    } catch(error) {
        return url;
    }
}

export default extractPathFromUrl;